import { render, staticRenderFns } from "./data_payment.vue?vue&type=template&id=2085df8b&scoped=true&"
import script from "./data_payment.vue?vue&type=script&lang=js&"
export * from "./data_payment.vue?vue&type=script&lang=js&"
import style0 from "./data_payment.vue?vue&type=style&index=0&id=2085df8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085df8b",
  null
  
)

export default component.exports